import React from "react";
import { Context, PageActionsPayload, PageContext } from "./types";

const DashboardPageContext = React.createContext<PageContext>({
	context: {},
	params: {},
	activatePageLoader: () => {},
	updateContext: (newValue: Context) => {
		return newValue;
	},
});

export default DashboardPageContext;
